import { ScreenReader } from 'ui/components';

export const ScreenReaderFeature: React.FC<Content.ScreenReader> = ({ content }) => {
	return <ScreenReader buttonText={content.buttonText} text={content.text} />;
};
